import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { Kcc20AdminApiService } from '../services/admin/kcc20-admin-api.service';
import { WalletManager } from '../managers/wallet.manager';

const ADMIN_ROLES = [
  'SYS_ADMIN',
  'LISTING_MANAGER',
  'TOKEN_METADATA_MANAGER',
  'FEE_TICKET_MANAGER',
  'MATCHER_OPERATOR',
];

export const adminRouteGuard: CanActivateFn = async (): Promise<
  boolean | UrlTree
> => {
  const walletManager = inject(WalletManager);
  const router = inject(Router);
  const adminApi = inject(Kcc20AdminApiService);

  // Mock builds (useMockData) serve fixture admin roles and have no real
  // wallet session — let the route render so the console is browsable.
  if (environment.useMockData) {
    return true;
  }

  // A hard navigation (page refresh / direct URL) can reach this guard
  // before the startup wallet session restore has resolved; wait for it so
  // an admin wallet with a valid remembered session isn't bounced just
  // because signedWalletSignal hasn't settled yet.
  await walletManager.awaitSessionRestore();

  if (!walletManager.signedWalletSignal()) {
    return router.parseUrl('/markets');
  }

  try {
    const admin = await firstValueFrom(adminApi.getMe());
    return admin.isAdmin ||
      admin.roles.some((role) => ADMIN_ROLES.includes(role))
      ? true
      : router.parseUrl('/markets');
  } catch {
    return router.parseUrl('/markets');
  }
};
